import './style.css'
import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import { Leva } from 'leva'
import Experience from './Experience.jsx'

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(
    <>
        <Leva
            oneLineLabels // default = false, alternative layout for labels, with labels and fields on separate rows
        />
        <Canvas
            shadows
            camera={ {
                fov: 50,
                near: 0.01,
                far: 200,
                position: [ - 5.9, 1.8, - 1.3 ]
            } }
            // antialias
        >
            <Experience />
        </Canvas>
    </>
)